<template>
  <div class="pb-10">
    <zt-data-table
      :columns="columns"
      :rows="workflowListTable"
      :config="{ pagination: { use: false }}"
    >
      <template v-slot:header>
        <div class="px-6 py-4 font-bold border-b bg-zt-white">
          <h2 class="text-zt-xl text-zt-dark-600">
            {{
              $t(
                'message.main_bussines_page.workflow.table.title'
              )
            }}
          </h2>
        </div>
      </template>

      <template v-slot:createdate="{ item }">
        <div class="flex justify-start items-center">
          <span class="ml-2 flex flex-wrap">{{ item.createdate }}</span>
        </div>
      </template>

      <template v-slot:modifiedby="{ item }">
        <div class="flex justify-start items-center">
          <zt-avatar :text="item.modifiedby" color="secondary-100" />
          <span class="ml-2 flex flex-wrap">{{ item.modifiedby }}</span>
        </div>
      </template>

      <template v-slot:name="{ item }">
        <div class="flex">
          <span>{{ item.name }}</span>
        </div>
      </template>

      <template v-slot:quantity="{ item }">
        <zt-tooltip
          :active="item.quantity"
          :text="$t('message.main_bussines_page.workflow.table.tooltipGroup')"
          position="left"
        >
          <zt-button
            outlined
            class="button-table-quantity"
            data-vs-button="workflow-quantity"
            @click="setWorkflowApproveTeam(item)"
          >
            <div class="flex items-center">
              <span>{{ item.quantity }}</span>
            </div>
          </zt-button>
        </zt-tooltip>
      </template>

      <template v-slot:status="{ item }">
        <div
          class="button-table-status flex items-center justify-center border rounded"
          :class="{
            'button-table-status--active': item.status === 1,
            'button-table-status--canceled': item.status === 0
          }"
        >
          <span>{{ getStatus(item.status) }}</span>
        </div>
      </template>

      <template v-slot:id="{ item }">
        <zt-tooltip
          :active="item.status === 1"
          :text="$t('message.main_bussines_page.workflow.table.tooltipCancel')"
          position="left"
        >
          <zt-button
            outlined
            class="button-table-action"
            :class="{
              'opacity-50': item.status === 0,
              'cursor-default': item.status === 0
            }"
            data-vs-button="workflow-delete"
            :disabled="item.status === 0"
            @click="setDisableWorkflow(item)"
          >
            <span>&times;</span>
          </zt-button>
        </zt-tooltip>
      </template>
    </zt-data-table>

    <modal-disable-workflow
      :item="rowItem"
      :active="activeDialog"
      :fn-disabled="updateTable"
      @close-disable-modal="toggleDialog"
    />

    <modal-group-list-workflow
      :item="rowGroupItem"
      :active="activeGroupListDialog"
      @close-group-modal="toggleGroupListDialog"
    />
  </div>
</template>

<script>
import moment from 'moment'
import ModalDisableWorkflow from "@/modules/Workflow/components/modals/ModalDisableWorkflow.vue"
import ModalGroupListWorkflow from "@/modules/Workflow/components/modals/ModalGroupListWorkflow.vue"
export default {
  name: "WorkflowListTable",
  components: {
    ModalDisableWorkflow,
    ModalGroupListWorkflow
  },
  props: {
    rows: {
      type: Array,
      default: () => ([])
    }
  },
  watch: {
    props: {
      handler() {
        this.workflowListTable = this.rows.map(rowItem => {
          return {
            ...rowItem,
            createdate: moment(rowItem.createdate).format('DD/MM/YY')
          }
        })
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      workflowListTable: [],
      activeDialog: false,
      activeGroupListDialog: false,
      columns: [
        {
          name: this.$t('message.main_bussines_page.workflow.table.headers.date'),
          dataField: 'createdate',
        },
        {
          name: this.$t('message.main_bussines_page.workflow.table.headers.modifiedby'),
          dataField: 'modifiedby',
        },
        {
          name: this.$t('message.main_bussines_page.workflow.table.headers.nameWorkflow'),
          dataField: 'name',
        },
        {
          name: this.$t('message.main_bussines_page.workflow.table.headers.groups'),
          dataField: 'quantity',
          width: 180
        },
        {
          name: this.$t('message.main_bussines_page.workflow.table.headers.status'),
          dataField: 'status',
          width: 180
        },
        {
          name: this.$t('message.main_bussines_page.workflow.table.headers.actions'),
          dataField: 'id',
          width: 100
        }
      ],
      rowItem: {},
      rowGroupItem: {}
    }
  },
  methods: {
    getStatus(status) {
      const obj = {
        0: this.$t('message.main_bussines_page.workflow.table.badge.cancelled'),
        1: this.$t('message.main_bussines_page.workflow.table.badge.active'),
      }
      return obj[status]
    },
    setDisableWorkflow(item) {
      this.rowItem = item
      this.toggleDialog()
    },
    setWorkflowApproveTeam(item) {
      this.rowGroupItem = item
      this.toggleGroupListDialog()
    },
    toggleDialog() {
      this.activeDialog = !this.activeDialog
      if (!this.activeDialog) {
        this.rowItem = {}
      }
    },
    toggleGroupListDialog() {
      this.activeGroupListDialog = !this.activeGroupListDialog
      if (!this.activeGroupListDialog) {
        this.rowGroupItem = {}
      }
    },
    updateTable(id) {
      const index = this.workflowListTable.findIndex(workflow => workflow.id === id)
      if (index !== -1) {
        this.$set(this.workflowListTable, index, { ...this.workflowListTable[index], status: 0 })
      }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .zt-data-table {
    thead,
    tbody,
    tfoot {
      background: #fff!important;
    }
    th {
      font-weight: 500!important;
    }
  }
  .button-table-action.zt-button {
    min-width: 40px!important;
    width: 40px;
    background: #fff!important;
    color: #707070!important;
    border-color: #707070!important;
    span {
      font-size: 2rem;
      line-height: 1;
    }
  }

  .button-table-quantity.zt-button {
    width: 156px!important;
    background: #EAE8F4!important;
    color: #4F41A3!important;
    border-color: #4F41A3!important;
  }

  .button-table-status {
    width: 156px!important;
    height: 36px;
    text-transform: uppercase;
  }

  .button-table-status--active {
    background: #EDFFF9!important;
    color: #379579!important;
    border-color: #379579!important;
  }

  .button-table-status--canceled {
    background: #EBEBEB!important;
    color: #707070!important;
    border-color: #707070!important;
  }

  .group-quantity {
    span:nth-child(2) {
      display: none;
    }
    :hover {
      span:nth-child(1) {
        display: none;
      }
      span:nth-child(2) {
        display: block;
      }
    }
  }
}
</style>